import { useCallback } from 'react';
import getIn from 'immutable-less/transmute/getIn';
import { useQuery, useMutation } from '@apollo/client';
import { GET_USER_SETTINGS_BY_KEYS_QUERY, GET_USER_SETTINGS_BY_KEYS_FIELDNAME, UPDATE_USER_SETTING_BY_KEY_MUTATION, UPDATE_USER_SETTING_BY_KEY_FIELDNAME } from 'automation-ui-core/hooks/userSettings/userSettingQueries';
export const useUserSettingByKey = userSettingKey => {
  const {
    loading,
    data
  } = useQuery(GET_USER_SETTINGS_BY_KEYS_QUERY, {
    variables: {
      keys: [userSettingKey]
    }
  });
  const userSettingsValue = getIn([GET_USER_SETTINGS_BY_KEYS_FIELDNAME, 0, 'value'], data);
  return loading ? undefined : userSettingsValue === 'true';
};
export const useUpdateShepherdDismissedStatus = userSettingKey => {
  const [updateShepherdDismissedStatus] = useMutation(UPDATE_USER_SETTING_BY_KEY_MUTATION, {
    update(cache, result) {
      const updatedUserSetting = getIn(['data', UPDATE_USER_SETTING_BY_KEY_FIELDNAME, 'updatedUserAttribute'], result);
      cache.writeQuery({
        query: GET_USER_SETTINGS_BY_KEYS_QUERY,
        data: {
          [GET_USER_SETTINGS_BY_KEYS_FIELDNAME]: [updatedUserSetting]
        },
        variables: {
          keys: [userSettingKey]
        }
      });
    }
  });
  return useCallback(value => updateShepherdDismissedStatus({
    variables: {
      key: userSettingKey,
      value
    }
  }), [userSettingKey, updateShepherdDismissedStatus]);
};